<template>
    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.99957 5.44883L11.6796 0.768828C11.8996 0.548828 12.1796 0.438828 12.5196 0.438828C12.8596 0.438828 13.1396 0.548828 13.3596 0.768828C13.5796 0.988828 13.6896 1.26883 13.6896 1.60883C13.6896 1.94883 13.5796 2.22883 13.3596 2.44883L7.83957 7.96883C7.71957 8.08883 7.58957 8.17383 7.44957 8.22383C7.30957 8.27383 7.15957 8.29883 6.99957 8.29883C6.83957 8.29883 6.68957 8.27383 6.54957 8.22383C6.40957 8.17383 6.27957 8.08883 6.15957 7.96883L0.63957 2.44883C0.41957 2.22883 0.30957 1.94883 0.30957 1.60883C0.30957 1.26883 0.41957 0.988828 0.63957 0.768828C0.85957 0.548828 1.13957 0.438828 1.47957 0.438828C1.81957 0.438828 2.09957 0.548828 2.31957 0.768828L6.99957 5.44883Z"
            fill="#64607D" />
    </svg>
</template>
<script>
export default {
    name: "DownBtnIcon",
};
</script>
<style lang="scss" scoped></style>